import clsx from "clsx";
import Table from "react-bootstrap/Table";
import React from "react";
import { Col, Row } from "react-bootstrap";
const paymentTermData = [
  {
    title: "No",
    value1: "1",
    value2: "Description",
    value3:
      "For fund transfer via bank platform (IBG/ Cash/ Cheque etc. ) Submit proof of deposit to TA Securities",
    value4: "For fund transfer via TA Securities FPX platform by using internet banking",
    width: "50px",
  },
  {
    title: "Payment Method",
    value1: "2",
    value2: "Transaction Limit",
    value3: "No Transaction Limit",
    value4: (
      <>
        Minimum transaction limit - RM1,000
        <br /> Maximum transaction limit - RM 250,000
      </>
    ),
    width: "100px",
  },
  {
    title: "Manual Transfer",
    value1: "3",
    value2: "Processing Time",
    value3: (
      <>
        8.30am - 5.00pm
        <br />
        Trading limit will be given upon verification of funds in our bank account.
        <br />
        Fund transfer after 3.00pm will be processed by the next working day.
      </>
    ),
    value4: "7.30am - 5.00pm Trading limit will be given upon confirmation",
    width: "300px",
  },
  {
    title: "FPX Direct Transfer",
    value1: "4",
    value2: "Admin Fees Charges",
    value3: (
      <>
        A service fee of RM1 per transaction will be charged for any refund of third party funds.
      </>
    ),
    width: "250px",
  },

];

function PaymentTermTable() {
  return (
    <div className={clsx("custom-table-info-container padding-12px")}>
      <Row>
        <Col sm={12} lg={6}>
          <div className="mt-3">*FPX Online Transfer</div>
          <Table className="withdrawal-table mt-2" style={{ width: "100%" }}>
            <tr>
              <th style={{ textAlign: "center" }} colSpan={2}>
                Transfer
              </th>
              <th style={{ textAlign: "center" }}>
                Process and Update in Account
              </th>
            </tr>
            <tr>
              <td>Day</td>
              <td>Time</td>
              <td></td>
            </tr>
            <tr>
              <td rowSpan={2}>
                Business Day <br />
                Monday to Friday
              </td>
              <td>Before 5pm</td>
              <td>By 5.30pm</td>
            </tr>
            <tr>
              <td>After 5pm</td>
              <td>By 5.30pm, Next Business Day</td>
            </tr>
            <tr>
              <td>
                Non-Business Day <br /> Saturday,Sunday & <br />
                Federal Territory Public <br />
                Holiday
              </td>
              <td>Anytime</td>
              <td>By 5.30pm, Next Business Day</td>
            </tr>
          </Table>
        </Col>
        <Col sm={12} lg={6}>
          <div className="mt-3">*Manual Transfer</div>
          <Table
            className="withdrawal-table mt-2"
            style={{ width: "100%" }}
          >
            <tr>
              <th style={{ textAlign: "center" }} colSpan={2}>
                Request Submit On
              </th>
              <th style={{ textAlign: "center" }}>
                Process and Update in Account
              </th>
            </tr>
            <tr>
              <td>Day</td>
              <td>Time</td>
              <td></td>
            </tr>
            <tr>
              <td rowSpan={2}>
                Business Day <br />
                Monday to Friday
              </td>
              <td>Before 4pm</td>
              <td>By 5.30pm</td>
            </tr>
            <tr>
              <td>After 4pm</td>
              <td>By 5.30pm, Next Business Day</td>
            </tr>
            <tr>
              <td>
                Non-Business Day <br /> Saturday,Sunday & <br />
                Federal Territory Public <br />
                Holiday
              </td>
              <td>Anytime</td>
              <td>By 5.30pm, Next Business Day</td>
            </tr>
          </Table>
        </Col>
      </Row>
      <div className="tnc-bottom-remark mt-4">
        <p>
          *Clients are discouraged from making cash deposit via Cash Deposit Machine (CDM).
        </p>
        <p>
          *Bank in slip with client signature is required for cash payment via CDM or Over the Counter (OTC).
        </p>
        <p>
          *Cumulative cash deposits exceeding <span className="text-bold-600">RM25k</span> for past 1 year requires
          our management approval and may take longer time to process.
        </p>
      </div>
      {/*<div className={"responsive-table-border table-w-1400"}>*/}
      {/*  <Table responsive="lg">*/}
      {/*    <thead>*/}
      {/*      <tr className={"custom-table-setoff-styled"}>*/}
      {/*        {paymentTermData.map((item) => (*/}
      {/*          <th key={item.title} style={{ minWidth: item.width }}>*/}
      {/*            {item.title}*/}
      {/*          </th>*/}
      {/*        ))}*/}
      {/*      </tr>*/}
      {/*    </thead>*/}
      {/*    <tbody>*/}
      {/*      {paymentTermData.map((item, index) => (*/}
      {/*        <tr key={index}>*/}
      {/*          <td key={item.value1}>{item.value1}</td>*/}
      {/*          <td key={item.value2}>{item.value2}</td>*/}
      {/*          <td key={item.value3}>{item.value3}</td>*/}
      {/*          <td key={item.value4}>{item.value4}</td>*/}
      {/*        </tr>*/}
      {/*      ))}*/}
      {/*    </tbody>*/}
      {/*    <tfoot className="epayment-table-footer">*/}
      {/*      <tr>*/}
      {/*        <th colSpan={4} style={{ color: "#138500" }}>*/}
      {/*          Deposit your fund using FPX Direct Transfer for Faster*/}
      {/*          Confirmation (don’t think we can grant limit immediately)*/}
      {/*        </th>*/}
      {/*      </tr>*/}
      {/*    </tfoot>*/}
      {/*  </Table>*/}
      {/*</div>*/}
    </div>

    // <div className={clsx("custom-table-info-container padding-12px")}>
    //   <div className={"responsive-table-border table-w-1400"}>
    //     <Table responsive="lg">
    //       <thead>
    //         <tr className={"custom-table-setoff-styled"}>
    //           {paymentTermData.map((item) => (
    //             <th key={item.title} style={{ minWidth: item.width }}>
    //               {item.title}
    //             </th>
    //           ))}
    //         </tr>
    //       </thead>
    //       <tbody>
    //         {paymentTermData.map((item, index) => (
    //           <tr key={index}>
    //             <td key={item.value1}>{item.value1}</td>
    //             <td key={item.value2}>{item.value2}</td>
    //             <td key={item.value3}>{item.value3}</td>
    //             <td key={item.value4}>{item.value4}</td>
    //           </tr>
    //         ))}
    //       </tbody>
    //       <tfoot className="epayment-table-footer">
    //         <tr>
    //           <th colSpan={4} style={{ color: "#138500" }}>
    //             Deposit your fund using FPX Direct Transfer for Faster Confirmation (don’t think we can grant limit immediately)
    //           </th>
    //         </tr>
    //       </tfoot>
    //     </Table>
    //   </div>
    // </div>
  );
}

export default PaymentTermTable;
